import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import { PhaseType } from 'modules/ats/lib/enums'

interface IApplicationPhase {
  id: string
  ats_job_posting_id: string
  editable: boolean
  name: string
  position: number
  phase_type?: PhaseType
  applications_count: number
  active_applications_count: number
}

class ApplicationPhase extends Model<IApplicationPhase> {
  constructor(attr: IApplicationPhase) {
    super(attr)
    makeObservable(this, {
      isHired: computed,
    })
  }

  static urlRoot() {
    return '/ats/application_phases'
  }

  get isInitial(): boolean {
    return this.attributes.phase_type === 'initial'
  }

  get isHired(): boolean {
    return this.attributes.phase_type === 'hired'
  }
}

export default ApplicationPhase
